<template>
  <v-tabs
    :value="currentTab"
    @change="updateTab"
    height="100%"
    class="app-tabs mb-4 ml-2"
  >
    <v-tab
      :ripple="false"
      v-for="(title, index) in tabTitles"
      :key="index"
      class="body-text--text"
    >
      <v-skeleton-loader v-if="!products[index]" type="text" width="100" height="20"/>
      <span v-else>
        {{ title }}
      </span>
    </v-tab>
  </v-tabs>
</template>

<style lang="scss" scoped>
.app-tabs {
  &::v-deep .v-slide-group__prev {
    display: none !important;
  }

  &::v-deep .v-tab--active.v-tab:not(:focus)::before {
    opacity: 0 !important;
  }

  &::v-deep .v-tab {
    text-transform: none !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: black !important;
    padding: 0 !important;
    margin-bottom: 8px;
    margin-right: 12px;
    min-width: 0px !important;
  }

  &::v-deep .v-tab:not(.v-tab--active) {
    color: #767676 !important;
  }
}
</style>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'

import { SET_CURRENT_TAB } from '../store/types'

export default Vue.extend({
  name: 'AppTabs',

  computed: mapGetters(['currentTab', 'tabTitles', 'products']),

  methods: {
    updateTab(newTab: number) {
      this.$store.commit(SET_CURRENT_TAB, newTab)
    },
  },
})
</script>
